/**
 * JobLoadingState Component - Loading and not found states
 */
import React from 'react';

interface JobLoadingStateProps {
  loading: boolean;
  job: any;
}

export const JobLoadingState: React.FC<JobLoadingStateProps> = ({ loading, job }) => {
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-6">
        <div className="max-w-7xl mx-auto">
          <p className="text-gray-600 dark:text-gray-400">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!job) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-6">
        <div className="max-w-7xl mx-auto">
          <p className="text-gray-600 dark:text-gray-400">Job não encontrado</p>
        </div>
      </div>
    );
  }

  return null;
};
